<template>
  <v-table
    :count="count"
    :list="list"
    :query-list="queryList"
    :is-loading="isLoading"
    :push-list="RouteConfig.voucherDeletedList.push"
    :is-show-student-select="true"
    :is-show-store-select="true"
    :is-multiple-store="true"
    :has-private-store="true"
    :is-show-limit-store-select="true"
    :is-multiple-limit-store="true"
    :has-private-limit-store="true"
    store-select-label="办理门店"
    limit-store-select-label="限制使用门店"
    student-select-label="所属学员"
    :show-summary="true"
  >
    <template slot="header-item">
      <div class="flex-align-center flex-wrap table-filter-item">
        <div class="flex-align-center table-filter-label">代金券类型：</div>
        <v-select-voucher-type
          v-model="queryList.voucher_type_ids"
          :multiple="true"
          :is-filter="true"
          :issue-types="[]"
          size="small"
          placeholder="输入名称搜索"
          @change="handleTypeChange"
        />
      </div>

      <v-select-voucher-status
        v-model="queryList.voucher_status"
        label="状态"
        size="small"
        clearable
        @change="handleStatusChange"
      />
    </template>
    <v-column-time value="退券时间" field="is_del" time-format="timeToYmdHi"/>
    <v-column-time sortable=""/>
    <v-column-time value="过期时间" field="expire_time" time-format="timeToYmdHi" sortable=""/>

    <el-table-column label="办理门店" prop="store_name"/>
    <el-table-column label="限制使用门店">
      <template v-slot="{ row }">
        <el-tag v-if="row.is_store_limited" size="small" type="warning">{{ row.limit_store_name }}</el-tag>
        <span v-else class="info-color">全部门店</span>
      </template>
    </el-table-column>
    <v-column-student label="所属学员" link-page-id="student_id"/>
    <el-table-column label="代金券类型" prop="voucher_type_name"/>
    <el-table-column label="面额（元）">
      <template v-slot="{ row }">{{ row.amount_in_cents | toYuan }}</template>
    </el-table-column>
    <el-table-column label="状态">
      <template v-slot="{ row }">
        <el-tag v-if="row.use_time" type="info" size="small">已使用</el-tag>
        <el-tag v-else-if="row.is_expired" type="danger" size="small">已过期</el-tag>
        <el-tag v-else type="success" size="small">可用</el-tag>
      </template>
    </el-table-column>

    <el-table-column width="120px" label="操作">
      <template v-slot="{ row }">
        <v-list-button :to="RouteConfig.voucherDetail.to(row.id)" name="查看" icon="view" :is-last="true"/>
      </template>
    </el-table-column>

    <template slot="mobile-list">
      <section class="list">
        <template v-if="list.length">
          <div
            v-for="(v, k) in list"
            :key="`voucher-deleted-list-${k}-${v.id}`"
            class="list-item primary-background-light"
          >
            <div class="list-item-detail">
              <span>添加时间</span>
              <span>{{ v.add_time | timeToYmdHi }}</span>
            </div>

            <div class="list-item-detail">
              <span>删除时间</span>
              <span>{{ v.is_del | timeToYmdHi }}</span>
            </div>

            <div class="list-item-detail">
              <span>办理门店</span>
              <span>{{ v.store_name }}</span>
            </div>

            <div class="list-item-detail">
              <span>限制使用门店</span>
              <span>{{ v.limit_store_name }}</span>
            </div>

            <div class="list-item-detail">
              <span>所属学员</span>
              <span>{{ v.student_name }}</span>
            </div>

            <div class="list-item-detail">
              <span>代金券类型</span>
              <span>{{ v.voucher_type_name }}</span>
            </div>

            <div class="list-item-detail">
              <span>面额（元）</span>
              <span>{{ v.amount_in_cents | toYuan }}</span>
            </div>

            <div class="list-item-detail">
              <span>过期时间</span>
              <span>{{ v.expire_time | timeToYmdHi('永久有效') }}</span>
            </div>

            <div class="list-item-detail">
              <span>状态</span>
              <span>
                <el-tag v-if="v.use_time" type="info" size="small">已使用</el-tag>
                <el-tag v-else-if="v.is_expired" type="danger" size="small">已过期</el-tag>
                <el-tag v-else type="success" size="small">可用</el-tag>
              </span>
            </div>

            <div class="list-item-button">
              <v-list-button :to="RouteConfig.voucherDetail.to(v.id)" :is-last="true"/>
            </div>
          </div>
        </template>

        <v-empty :is-loading="isLoading" :length="list.length"/>
      </section>
    </template>
  </v-table>
</template>

<script>
import RouteConfig from '@/router/config';
import { getLegalQueryList } from '@/utils/formats';
import { index } from '@/api/voucher';

export default {
  name: RouteConfig.voucherDeletedList.name,
  data: () => ({
    RouteConfig,
    isLoading: false,
    count: 0,
    list: [],
    queryList: {
      student_ids: [],
      store_ids: [],
      limit_store_ids: [],
      voucher_type_ids: [],
      voucher_status: 0,
      is_del: 1,
      is_asc: 0,
      page: 1,
      size: 10,
    },
  }),
  computed: {
    defaultStoreId() { return this.$store.getters.defaultStoreId; },
  },
  watch: {
    '$route'(to) {
      this.load(to);
    },
  },
  beforeMount() {
    this.load();
  },
  methods: {
    handleStatusChange(value) {
      this.queryList.page = 1;
      this.queryList.voucher_status = value || 0;
      RouteConfig.voucherDeletedList.push({ ...this.queryList });
    },
    handleTypeChange(value) {
      this.queryList.voucher_type_ids = value || [];
      this.queryList.page = 1;
      RouteConfig.voucherDeletedList.push({ ...this.queryList });
    },
    async load(route = this.$route, next) {
      const { queryList } = this;
      const { query } = route;

      queryList.store_id = this.defaultStoreId;
      getLegalQueryList(queryList, query);

      const params = { ...queryList };
      this.isLoading = true;
      const { isError, data } = await index(params);
      this.isLoading = false;
      if (isError) return;

      this.count = data.count;
      this.list = data.list;
      if (next) next();
    },
  },
};
</script>
